export interface ContextHubItem {
  id: string;
  kind: 'generated' | 'note' | 'memory';
  title: string;
  summary: string;
  content: string | null;
  searchText: string | null;
  status: 'generating' | 'ready' | 'failed';
  sourceType: 'github_repo' | 'warehouse' | 'manual' | 'chat';
  sourceRef: string | null;
  sourceLabel: string | null;
  editable: boolean;
  createdViaAi: boolean;
  category: string | null;
  docType: 'source' | 'warehouse' | null;
  typeLabel: string | null;
  repoFullName: string | null;
  adherence: 'reference' | 'skill';
  skillDescription: string | null;
  skillEnabled: boolean;
  skillPromotedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export const CONTEXT_KIND_LABELS: Record<ContextHubItem['kind'], string> = {
  generated: 'Generated',
  note: 'Note',
  memory: 'Memory',
};

export const CONTEXT_SOURCE_LABELS: Record<ContextHubItem['sourceType'], string> = {
  github_repo: 'GitHub repo',
  warehouse: 'Warehouse',
  manual: 'Manual note',
  chat: 'Chat',
};

export function getContextItemPath(item: Pick<ContextHubItem, 'id' | 'kind'>): string {
  if (item.kind === 'generated') return `/context/generated/${item.id}`;
  return `/context/${item.kind}/${item.id}`;
}
